import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "reactstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BsTable } from "react-icons/bs";
import {
  exportToTxt,
  generateExcel,
  numberWithCommas,
} from "../../utils/customFunction";
import { useSelector } from "react-redux";
import html2pdf from "html2pdf.js";
import CardColComponent from "../genericCardComponent/CardColComponent";
import ReportTemplates from "../../components/ReportTemplate/ReportTemplate";
import moment from "moment";
import { getFunds } from "../../stores/services/funds.service";
import Select from "react-select";
import { getProvidentFundProfitSummary } from "../../stores/services/provident-funds.service";
import { getAllCompanies } from "../../stores/services/company.service";

const PFProfitSummaryReport = () => {
  const ColumnHeading = [
    {
      label: "Employee Code",
      value: "Employee Code",
    },
    {
      label: "Employee Name",
      value: "Employee Name",
    },
    {
      label: "CNIC",
      value: "CNIC",
    },
    {
      label: "Employee Contribution",
      value: "Employee Contribution",
    },
    {
      label: "Employer Contribution",
      value: "Employer Contribution",
    },
    {
      label: "Investment Option",
      value: "Investment Option",
    },
    {
      label: "Total Profit",
      value: "Total Profit",
    },
    {
      label: "Loan Amount",
      value: "Loan Amount",
    },
    {
      label: "Net Total",
      value: "Net Total",
    },
  ];

  const email = sessionStorage.getItem("email") || "";
  const amc_code = sessionStorage.getItem("amc_code") || "";
  const theme = useSelector((state: any) => state.ThemeModeReducer.Theme);
  const contentRef = React.useRef(null);
  const [ColumnArr, setColumnArr] = useState(ColumnHeading);
  const [selectedValues, setSelectedValues] = useState({
    heading: "",
    sub_heading: "",
    columns: ColumnHeading?.map?.((col) => col?.value),
    balance: [],
  });
  const [fontSizeVal, setFontSizeVal] = useState(18);
  const [paperSizeVal, setPaperSizeVal] = useState("A4");
  const [layoutVal, setLayoutVal] = useState("Landscape");
  const [marginPDF, setMarginPDF] = useState("1cm");
  const [scalePDF, setScalePDF] = useState(0.5);
  const [screenSizePerPdf, setScreenSizePerPdf] = useState<any>();
  const [dimensionOfPages, setDimensionOfPages] = useState<any>();
  const pdfExportComponent = React.useRef(null);
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [fund, setFund] = useState("");
  const [fundLoading, setFundLoading] = useState<boolean>(false);
  const [allFunds, setAllFunds] = useState<any>([]);
  const [overallSummary, setOverallSummary] = useState<any>({
    total_employee_contribution: 0,
    total_employer_contribution: 0,
    total_profit: 0,
    total_loan_amount: 0,
    overall_net_total: 0,
  });

  const [loadingCompany, setLoadingCompany] = useState(false);
  const [companyOptions, setCompanyOptions] = useState<any[]>([]);
  const [companyName, setCompanyName] = useState<any>();

  // Fetch Companies
  useEffect(() => {
    const fetchAllCompanies = async () => {
      try {
        setLoadingCompany(true);
        const resp = await getAllCompanies({ email, fetch_all: "all" });
        if (resp.data.status === 200) {
          const options = resp.data.data.map((data: any) => ({
            ...data,
            value: data.company_code,
            label: `${data.name_of_company} (${data.company_code})`,
          }));
          setCompanyOptions(options);
        }
      } catch (error) {
        toast.error("Failed to load companies");
      } finally {
        setLoadingCompany(false);
      }
    };
    fetchAllCompanies();
  }, []);

  // Fetch Funds when Company changes
  useEffect(() => {
    const getAllFunds = async () => {
      if (!companyName?.value) return;
      try {
        const res = await getFunds({
          email,

          company_name: companyName.value,
        });
        setAllFunds(res.data.data || []);
      } catch (error) {
        toast.error("Failed to load funds");
      }
    };
    getAllFunds();
  }, [companyName]);

  const searchData = async () => {
    try {
      setLoading(true);
      const response = await getProvidentFundProfitSummary(
        email,
        amc_code,
        fund,
        ""
      );

      if (response.data.status === 200 && response?.data?.data?.length > 0) {
        const dataIs = response?.data?.data;
        const summaryData = response?.data?.summary;

        setTableData(dataIs);
        setOverallSummary(summaryData);
      } else {
        setTableData([]);
        toast.error("No record found!");
      }
    } catch (error: any) {
      setTableData([]);
      toast.error("No record found!");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const elements = document.querySelectorAll(
      "#test"
    ) as NodeListOf<HTMLElement>;
    elements.forEach((element) => {
      element.style.setProperty("font-size", `${fontSizeVal}px`, "important");
    });
  }, [fontSizeVal, selectedValues, loading]);

  const fixedOrder = [
    "Employee Code",
    "Employee Name",
    "CNIC",
    "Employee Contribution",
    "Employer Contribution",
    "Investment Option",
    "Total Profit",
    "Loan Amount",
    "Net Total",
  ];

  const reorderColumns = (columns, order) => {
    return order.filter((column) => columns.includes(column));
  };

  // Excel Export Function
  const handleDownloadExcel = () => {
    const reorderedColumns = reorderColumns(
      selectedValues?.columns,
      fixedOrder
    );

    const ArrayData = tableData.map((entry: any) => {
      const result = {};
      reorderedColumns.forEach((column) => {
        if (column === "Employee Code") result[column] = entry.employee_code;
        else if (column === "Employee Name")
          result[column] = entry.employee_name;
        else if (column === "CNIC") result[column] = entry.employee_cnic;
        else if (column === "Employee Contribution")
          result[column] = entry.total_employee_contribution;
        else if (column === "Employer Contribution")
          result[column] = entry.total_employer_contribution;
        else if (column === "Investment Option")
          result[column] = entry.investment_option;
        else if (column === "Total Profit") result[column] = entry.total_profit;
        else if (column === "Loan Amount") result[column] = entry.loan_amount;
        else if (column === "Net Total") result[column] = entry.net_total;
        else result[column] = "";
      });
      return result;
    });

    generateExcel(
      "PF Profit Summary Report",
      "PF Profit Summary Report",
      "File",
      "File",
      "DCCL",
      [],
      reorderedColumns,
      ArrayData,
      [],
      []
    );
  };

  // TXT Export Function
  const handleTXT = () => {
    const reorderedColumns = reorderColumns(
      selectedValues?.columns,
      fixedOrder
    );
    const ArrayData = tableData.map((entry: any) => {
      const result = {};
      reorderedColumns.forEach((column) => {
        if (column === "Employee Code") result[column] = entry.employee_code;
        else if (column === "Employee Name")
          result[column] = entry.employee_name;
        else if (column === "CNIC") result[column] = entry.employee_cnic;
        else if (column === "Employee Contribution")
          result[column] = entry.total_employee_contribution;
        else if (column === "Employer Contribution")
          result[column] = entry.total_employer_contribution;
        else if (column === "Total Profit") result[column] = entry.total_profit;
        else if (column === "Loan Amount") result[column] = entry.loan_amount;
        else if (column === "Net Total") result[column] = entry.net_total;
        else result[column] = "";
      });
      return result;
    });

    exportToTxt("", selectedValues, ArrayData, "PF Profit Summary Report");
  };

  // PDF Export Function
  const handleGeneratePdf = () => {
    const element = contentRef.current;
    let fileName = "PF-Profit-Summary-Report.pdf";
    const options = {
      filename: fileName,
      margin: [10, 3, 20, 3],
      image: { type: "jpeg", quality: 0.95 },
      html2canvas: { scale: 1 },
      jsPDF: {
        unit: "mm",
        format: paperSizeVal || "A4",
        orientation: layoutVal === "Landscape" ? "landscape" : "portrait",
      },
      pagebreak: { mode: ["avoid-all", "css", "legacy"] },
    };

    html2pdf()
      .from(element)
      .set(options)
      .toPdf()
      .get("pdf")
      .then((pdf) => {
        const totalPages = pdf.internal.getNumberOfPages();
        for (let i = 1; i <= totalPages; i++) {
          pdf.setPage(i);
          pdf.setFontSize(10);
          pdf.setTextColor(128, 128, 128);
          const pageWidth = pdf.internal.pageSize.getWidth();
          const pageHeight = pdf.internal.pageSize.getHeight();
          pdf.text(
            "This is a computer-generated report from MACS 360. No signature is required.",
            pageWidth / 2,
            pageHeight - 10,
            { align: "right" }
          );
        }
      })
      .save();
  };

  const renderFundsDropdown = () => {
    let temp: any = [];
    temp = allFunds.map((item: any) => {
      if (item.nature === "Special Managed Account") {
        return {
          value: item.symbol_code,
          label: `${item.fund_name} (${item.symbol_code}) - SMA`,
        };
      } else {
        return {
          value: item.symbol_code,
          label: `${item.fund_name} (${item.symbol_code})`,
        };
      }
    });
    return temp;
  };

  const selectedFundName = React.useMemo(() => {
    const selectedFund = allFunds.find((item) => item?.symbol_code === fund);
    return selectedFund && selectedFund.nature === "Special Managed Account"
      ? {
          value: selectedFund.symbol_code,
          label: `${selectedFund.fund_name} (${selectedFund.symbol_code}) - SMA`,
        }
      : selectedFund
      ? {
          value: selectedFund.symbol_code,
          label: `${selectedFund.fund_name} (${selectedFund.symbol_code})`,
        }
      : null;
  }, [allFunds, fund]);

  const customStyles = {
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    option: (styles, { isFocused, isSelected }) => ({
      ...styles,
      background: isFocused
        ? "hsla(291, 64%, 42%, 0.5)"
        : isSelected
        ? "hsla(291, 64%, 42%, 1)"
        : undefined,
      zIndex: 1,
    }),
    menuList: (styles) => ({
      ...styles,
      background: theme == "dark" ? "#3b3b3b" : "#ffffff",
      color: theme == "dark" ? "white" : "",
    }),
    menu: (base) => ({
      ...base,
      zIndex: 100,
    }),
    control: (base, state) => ({
      ...base,
      background: theme == "dark" ? "#25273a" : "#f2f2f2",
      borderRadius: "0.4285rem",
      borderColor: state.isFocused
        ? "#1d8cf8"
        : theme !== "light"
        ? "#2b3553"
        : "",
      boxShadow: state.isFocused ? null : null,
      "&:hover": {
        borderColor: state.isFocused ? "" : "#ba54f5",
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      color: theme == "dark" ? "white" : "black",
    }),
    input: (base) => ({
      ...base,
      color: theme == "dark" ? "white" : "black",
    }),
  };

  const decentStyle = (valueIs) => {
    return (
      <CardColComponent
        subTitle={valueIs}
        simple={true}
        amount={true}
        forTxn={true}
      />
    );
  };

  const summaryDetailsArr = [
    {
      title: "Employee Contribution",
      value: overallSummary?.total_employee_contribution,
      isAmount: true,
      fixed: 2,
    },
    {
      title: "Employer Contribution",
      value: overallSummary?.total_employer_contribution,
      isAmount: true,
      fixed: 2,
    },
    {
      title: "Total Profit",
      value: overallSummary?.total_profit,
      isAmount: true,
      fixed: 2,
    },
    {
      title: "Total Loan Amount",
      value: overallSummary?.total_loan_amount,
      isAmount: true,
      fixed: 2,
    },
    {
      title: "Overall Net Total",
      value: overallSummary?.overall_net_total,
      isAmount: true,
      fixed: 2,
    },
  ];

  return (
    <>
      <div className="content">
        <Row>
          <Col md="12">
            <Container fluid>
              <ToastContainer limit={1} />
              <div className="">
                <div className="card">
                  <div className="card-header">
                    <h4 className="card-title">
                      Provident Fund Profit Summary Report
                    </h4>
                  </div>
                  <div className="card-body">
                    <Row className="align-items-center">
                      <Col className="form-group col-md-4">
                        <label>
                          Company Name <span className="color-amber">*</span>
                        </label>
                        <Select
                          className="react-select info"
                          isLoading={loadingCompany}
                          value={companyName}
                          onChange={setCompanyName}
                          menuPortalTarget={document.body}
                          menuShouldBlockScroll
                          isClearable
                          isSearchable
                          options={companyOptions}
                          styles={customStyles}
                        />
                      </Col>
                      <Col md="4" xs="12" className="mb-3 mb-md-0">
                        <div className="form-group">
                          <label>
                            Fund <span className="color-amber">*</span>
                          </label>
                          {fundLoading ? (
                            <div className="form-control w-100">
                              <i className="fa fa-spinner fa-spin fa-1x"></i>
                            </div>
                          ) : (
                            <Select
                              isDisabled={!companyName?.value}
                              value={selectedFundName}
                              label={fundLoading ? "Loading..." : "Select Fund"}
                              onChange={(e) => {
                                setFund(e?.value);
                              }}
                              menuPortalTarget={document.body}
                              menuShouldBlockScroll={true}
                              isClearable={true}
                              isSearchable={true}
                              name="color"
                              options={renderFundsDropdown()}
                              styles={customStyles}
                            />
                          )}
                        </div>
                      </Col>

                      <Col
                        md="auto"
                        xs="6"
                        className="d-flex align-items-end mt-3 mb-md-0"
                      >
                        <button
                          className="btn btn-primary"
                          onClick={() => {
                            if (fund) {
                              searchData();
                            } else {
                              toast.error("Fund should not be empty");
                            }
                          }}
                          disabled={Boolean(loading)}
                        >
                          {loading ? (
                            <>
                              <span
                                className="spinner-border login-txt spinner-border-sm"
                                role="status"
                                aria-hidden="true"
                              ></span>
                              <span className="login-txt"> Loading...</span>
                            </>
                          ) : (
                            <span>Search</span>
                          )}
                        </button>
                      </Col>
                    </Row>
                  </div>
                </div>

                {/* Report Data Display */}
                <div className="card mt-3">
                  <div className="card-body">
                    {tableData?.length > 0 && (
                      <Row>
                        <ReportTemplates
                          ColumnArr={ColumnArr}
                          selectedValues={selectedValues}
                          setSelectedValues={setSelectedValues}
                          pdfExportComponent={pdfExportComponent}
                          setFontSizeVal={setFontSizeVal}
                          fontSizeVal={fontSizeVal}
                          setPaperSizeVal={setPaperSizeVal}
                          paperSizeVal={paperSizeVal}
                          setLayoutVal={setLayoutVal}
                          layoutVal={layoutVal}
                          setScalePDF={setScalePDF}
                          scalePDF={scalePDF}
                          setMarginPDF={setMarginPDF}
                          marginPDF={marginPDF}
                          setScreenSizePerPdf={setScreenSizePerPdf}
                          screenSizePerPdf={screenSizePerPdf}
                          setDimensionOfPages={setDimensionOfPages}
                          contentRef={contentRef}
                          fileName={"PF-Profit-Summary-Report.pdf"}
                          printExcel={handleDownloadExcel}
                          printTXT={handleTXT}
                          printpdf={handleGeneratePdf}
                        />
                      </Row>
                    )}

                    <div
                      id="printDiv"
                      className="p-4"
                      style={{
                        color: "black",
                        minWidth: "200px",
                        overflowX: "auto",
                        width: "auto",
                      }}
                    >
                      <div
                        style={{
                          width: `${
                            dimensionOfPages?.find(
                              (item) => item?.key == paperSizeVal
                            )?.dimensions[layoutVal == "Portrait" ? 0 : 1]
                          }`,
                          height: "auto",
                          margin: "0 auto",
                          backgroundColor: "white",
                        }}
                        className="border"
                      >
                        <div
                          style={{
                            margin: "0.25in",
                          }}
                          ref={contentRef}
                        >
                          {tableData.length > 0 ? (
                            <>
                              <div className="row align-items-center">
                                <div className="col-4 d-flex justify-content-start">
                                  <img
                                    src={
                                      companyName?.company_logo
                                        ? companyName?.company_logo
                                        : ""
                                    }
                                    alt="Company-Logo"
                                    style={{
                                      width: "auto",
                                      height: "33px",
                                    }}
                                  />
                                </div>
                                <div className="col-8 d-flex flex-column align-items-center justify-content-center">
                                  <h6 className="text-black mt-2 mb-0">
                                    Provident Fund Profit Summary Report
                                  </h6>
                                  <span>
                                    {selectedFundName?.label || "All Funds"}
                                  </span>
                                </div>
                              </div>
                              {/* Overall Summary */}
                              <Col className="px-0" xs={12}>
                                <div className="m-1 p-2 small">
                                  <div className="card-header py-2 px-3 border-bottom">
                                    <div className="text-black d-flex align-items-center">
                                      <span>Overall Fund Summary</span>
                                    </div>
                                  </div>
                                  <div className="text-black card-body p-2">
                                    <div className="d-flex flex-wrap">
                                      {summaryDetailsArr.map((item, i) => (
                                        <div
                                          className="flex-item pr-5 pb-3"
                                          key={i}
                                        >
                                          <CardColComponent
                                            title={item.title}
                                            subTitle={numberWithCommas(
                                              parseFloat(
                                                String(item.value)
                                              ).toFixed(item.fixed || 2)
                                            )}
                                            amount={item.isAmount}
                                          />
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                </div>
                              </Col>{" "}
                              <div className="mt-3">
                                <table
                                  className=""
                                  style={{
                                    color: "black",
                                    width: "100%",
                                    borderCollapse: "collapse",
                                    tableLayout: "fixed",
                                  }}
                                >
                                  <thead>
                                    <tr
                                      style={{
                                        borderTop: "2px solid black",
                                        borderBottom: "2px solid black",
                                      }}
                                    >
                                      {/* --- HEADERS (Existing code) --- */}
                                      {selectedValues?.columns?.includes(
                                        "Employee Code"
                                      ) && (
                                        <th
                                          id="test"
                                          style={{
                                            width: "10%",
                                            textAlign: "left",
                                            padding: "8px 4px",
                                          }}
                                        >
                                          Emp Code
                                        </th>
                                      )}
                                      {selectedValues?.columns?.includes(
                                        "Employee Name"
                                      ) && (
                                        <th
                                          id="test"
                                          style={{
                                            width: "15%",
                                            textAlign: "left",
                                            padding: "8px 4px",
                                          }}
                                        >
                                          Emp Name
                                        </th>
                                      )}
                                      {selectedValues?.columns?.includes(
                                        "CNIC"
                                      ) && (
                                        <th
                                          id="test"
                                          style={{
                                            width: "12%",
                                            textAlign: "left",
                                            padding: "8px 4px",
                                          }}
                                        >
                                          CNIC
                                        </th>
                                      )}
                                      {selectedValues?.columns?.includes(
                                        "Employee Contribution"
                                      ) && (
                                        <th
                                          id="test"
                                          style={{
                                            width: "13%",
                                            textAlign: "right",
                                            padding: "8px 4px",
                                          }}
                                        >
                                          Employee Contirbution
                                        </th>
                                      )}
                                      {selectedValues?.columns?.includes(
                                        "Employer Contribution"
                                      ) && (
                                        <th
                                          id="test"
                                          style={{
                                            width: "13%",
                                            textAlign: "right",
                                            padding: "8px 4px",
                                          }}
                                        >
                                          Employeer Contirbution
                                        </th>
                                      )}
                                      {selectedValues?.columns?.includes(
                                        "Investment Option"
                                      ) && (
                                        <th
                                          id="test"
                                          style={{
                                            width: "13%",
                                            textAlign: "right",
                                            padding: "8px 4px",
                                          }}
                                        >
                                          Investment Option
                                        </th>
                                      )}
                                      {selectedValues?.columns?.includes(
                                        "Total Profit"
                                      ) && (
                                        <th
                                          id="test"
                                          style={{
                                            width: "12%",
                                            textAlign: "right",
                                            padding: "8px 4px",
                                          }}
                                        >
                                          Total Profit
                                        </th>
                                      )}
                                      {selectedValues?.columns?.includes(
                                        "Loan Amount"
                                      ) && (
                                        <th
                                          id="test"
                                          style={{
                                            width: "12%",
                                            textAlign: "right",
                                            padding: "8px 4px",
                                          }}
                                        >
                                          Loan Amount
                                        </th>
                                      )}
                                      {selectedValues?.columns?.includes(
                                        "Net Total"
                                      ) && (
                                        <th
                                          id="test"
                                          style={{
                                            width: "13%",
                                            textAlign: "right",
                                            padding: "8px 4px",
                                          }}
                                        >
                                          Net Total
                                        </th>
                                      )}
                                    </tr>
                                  </thead>

                                  {/* --- BODY (This was missing) --- */}
                                  <tbody>
                                    {tableData.map((item: any, index) => (
                                      <tr
                                        key={index}
                                        style={{
                                          borderBottom: "1px solid #e3e3e3",
                                        }}
                                      >
                                        {selectedValues?.columns?.includes(
                                          "Employee Code"
                                        ) && (
                                          <td
                                            id="test"
                                            style={{
                                              textAlign: "left",
                                              padding: "8px 4px",
                                            }}
                                          >
                                            {item.employee_code}
                                          </td>
                                        )}
                                        {selectedValues?.columns?.includes(
                                          "Employee Name"
                                        ) && (
                                          <td
                                            id="test"
                                            style={{
                                              textAlign: "left",
                                              padding: "8px 4px",
                                            }}
                                          >
                                            {item.employee_name}
                                          </td>
                                        )}
                                        {selectedValues?.columns?.includes(
                                          "CNIC"
                                        ) && (
                                          <td
                                            id="test"
                                            style={{
                                              textAlign: "left",
                                              padding: "8px 4px",
                                            }}
                                          >
                                            {item.employee_cnic}
                                          </td>
                                        )}
                                        {selectedValues?.columns?.includes(
                                          "Employee Contribution"
                                        ) && (
                                          <td
                                            id="test"
                                            style={{
                                              textAlign: "right",
                                              padding: "8px 4px",
                                            }}
                                          >
                                            {numberWithCommas(
                                              parseFloat(
                                                item.total_employee_contribution ||
                                                  0
                                              ).toFixed(2)
                                            )}
                                          </td>
                                        )}
                                        {selectedValues?.columns?.includes(
                                          "Employer Contribution"
                                        ) && (
                                          <td
                                            id="test"
                                            style={{
                                              textAlign: "right",
                                              padding: "8px 4px",
                                            }}
                                          >
                                            {numberWithCommas(
                                              parseFloat(
                                                item.total_employer_contribution ||
                                                  0
                                              ).toFixed(2)
                                            )}
                                          </td>
                                        )}
                                        {selectedValues?.columns?.includes(
                                          "Investment Option"
                                        ) && (
                                          <td
                                            id="test"
                                            style={{
                                              width: "13%",
                                              textAlign: "right",
                                              padding: "8px 4px",
                                            }}
                                          >
                                            {item.investment_option}
                                          </td>
                                        )}
                                        {selectedValues?.columns?.includes(
                                          "Total Profit"
                                        ) && (
                                          <td
                                            id="test"
                                            style={{
                                              textAlign: "right",
                                              padding: "8px 4px",
                                            }}
                                          >
                                            {numberWithCommas(
                                              parseFloat(
                                                item.total_profit || 0
                                              ).toFixed(2)
                                            )}
                                          </td>
                                        )}
                                        {selectedValues?.columns?.includes(
                                          "Loan Amount"
                                        ) && (
                                          <td
                                            id="test"
                                            style={{
                                              textAlign: "right",
                                              padding: "8px 4px",
                                            }}
                                          >
                                            {numberWithCommas(
                                              parseFloat(
                                                item.loan_amount || 0
                                              ).toFixed(2)
                                            )}
                                          </td>
                                        )}
                                        {selectedValues?.columns?.includes(
                                          "Net Total"
                                        ) && (
                                          <td
                                            id="test"
                                            style={{
                                              textAlign: "right",
                                              padding: "8px 4px",
                                            }}
                                          >
                                            {numberWithCommas(
                                              parseFloat(
                                                item.net_total || 0
                                              ).toFixed(2)
                                            )}
                                          </td>
                                        )}
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            </>
                          ) : (
                            <div className="table-empty">
                              <BsTable className="icon" />
                              <p className="text-center text-primary empty-text">
                                No profit summary data found.
                              </p>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Container>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default PFProfitSummaryReport;
